module.exports = __webpack_public_path__ + "img/meditation_1000.af8b908e.svg";